import React, { FC } from 'react';
import { View, ViewStyle, StyleSheet, TouchableOpacity } from 'react-native';

import colors from '@packages/core/styles/colors';
import { Icon } from '../icon';

interface IProgressBarProps {
    percent: number;
    style?: ViewStyle;
    onCancel?: () => void;
    disabledCancel?: boolean;
}

const styles = StyleSheet.create({
    wrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    track: {
        flex: 1,
        height: 8,
        backgroundColor: '#D9D9D9',
        borderRadius: 4,
        overflow: 'hidden',
    },
    fill: {
        height: '100%',
        backgroundColor: `${colors.blueOne}`,
        borderRadius: 4,
    },
    cancelButton: {
        marginLeft: 8,
    },
    disabled: {
        opacity: 0.32,
    },
});

export const ProgressBar: React.FC<IProgressBarProps> = ({ disabledCancel, percent, style, onCancel }) => {
    return (
        <View style={[styles.wrapper, style]}>
            <View style={styles.track}>
                <View style={[styles.fill, { width: `${percent}%` }]} />
            </View>
            {onCancel && (
                <TouchableOpacity
                    onPress={onCancel}
                    style={[styles.cancelButton, disabledCancel && styles.disabled]}
                    disabled={disabledCancel}
                >
                    <Icon name="x-circle" />
                </TouchableOpacity>
            )}
        </View>
    );
};
